import { Editor, EditorPlugin, PluginEvent, PluginEventType, PositionType, isNodeEmpty } from "RoosterReact/rooster-react-amd";

export class HtmlEditorEscapeCodeBlockPlugin implements EditorPlugin {
    private _editor: Editor;

    public getName(): string {
        return "KeyDownPlugin";
    }

    public dispose(): void {
        this._editor = null;
    }

    public initialize(editor: Editor): void {
        this._editor = editor;
    }

    public onPluginEvent(event: PluginEvent): void | undefined {
        if (event.eventType === PluginEventType.KeyDown) {
            this._handleKeyDown(event.rawEvent);
        }
    }

    /**
     * We want to escape a code block if the cursor is on a blank line at the
     * end of a code block and the user hits enter. Shift+Enter will add a
     * blank line in the code block as usual.
     */
    private _handleKeyDown(event: KeyboardEvent) {
        if (event.key === "Enter" && !event.shiftKey && this._isCursorOnBlankLastLineInCodeBlock()) {
            this._escapeCodeBlock();
            event.stopPropagation();
            event.preventDefault();
        }
    }

    /**
     * RoosterJS code blocks are surrounded by <pre><code></code></pre>.
     * If we are on a blank line at the end of a code block, the current element
     * will always be the last immediate child of the <code> element.
     */
    private _isCursorOnBlankLastLineInCodeBlock() {
        const currentElement = this._editor.getElementAtCursor();
        const parent = currentElement.parentElement;
        const grandparent = parent?.parentElement;

        return (
            parent?.tagName === "CODE" &&
            grandparent?.tagName === "PRE" &&
            currentElement === parent?.lastElementChild &&
            isNodeEmpty(currentElement)
        );
    }

    /**
     * Add a blank line after the <pre> element and put the cursor on that new blank line
     */
    private _escapeCodeBlock() {
        this._editor.addUndoSnapshot(() => {
            const currentElement = this._editor.getElementAtCursor();
            const preBlock = currentElement.parentElement!.parentElement!;

            const newDiv = document.createElement("div");
            // Including a <br> is how RoosterJS displays empty lines
            newDiv.appendChild(document.createElement("br"));
            preBlock.after(newDiv);

            this._editor.select(newDiv, PositionType.Begin);
        });
    }
}
